
import { ArrowRight, User } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export default function WebViewCard({ title, icon, actionIcon,path, newWindow}) {
const navigate = useNavigate()
function handleClick(){
    if(newWindow){
        window.open(path, '_blank');
    }else{
    navigate(path)
    }
}
  return (
    <div onClick={handleClick}  className="flex items-center justify-between w-full sm:w-[300px] p-3 gap-4 border border-gray-200 rounded-xl hover:shadow-md transition-all bg-white">
      <div className="flex-1  font-medium">
        {title}
      </div>
      {actionIcon || <ArrowRight className="text-gray-500 w-5 h-5" />}
    </div>
    
  );
}

